import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

import { CounterpartyConnectionsTable } from './CounterpartyConnectionsTable';
import { CounterpartyConnectionsToolbar } from './CounterpartyConnectionsToolbar';
import { type CounterpartyConnectionItem } from './CounterpartyConnections.helpers';
import { useCounterpartyConnectionsView } from './useCounterpartyConnectionsView';

import styles from './CounterpartyConnections.module.sass';

interface CounterpartyConnectionsProps {
  connections: CounterpartyConnectionItem[] | null | undefined;
  connectionAmountDivisor?: number;
  tooltip?: string;
}

const CounterpartyConnections = ({
  connections,
  connectionAmountDivisor,
  tooltip,
}: CounterpartyConnectionsProps) => {
  const { t } = useTranslation();
  const {
    headingId,
    segment,
    setSegment,
    filterOpen,
    setFilterOpen,
    namedConnections,
    visibleConnections,
    filterPanelActive,
    filterPanelElement,
  } = useCounterpartyConnectionsView(connections);

  if (namedConnections.length === 0) {
    return null;
  }

  return (
    <div className={styles.connections}>
      <div className={styles.title} id={headingId}>
        <span className={styles.titleBeta}>beta</span>
        {t('translation.connected_entities')}
        {tooltip && (
          <Tooltip title={tooltip}>
            <span className={styles.titleHint}>i</span>
          </Tooltip>
        )}
      </div>

      <CounterpartyConnectionsToolbar
        headingId={headingId}
        segment={segment}
        onSegmentChange={setSegment}
        filterOpen={filterOpen}
        onFilterOpenChange={setFilterOpen}
        filterPanelActive={filterPanelActive}
        filterContent={filterPanelElement}
      />
      <CounterpartyConnectionsTable
        rows={visibleConnections}
        segment={segment}
        connectionAmountDivisor={connectionAmountDivisor}
      />
    </div>
  );
};

export default CounterpartyConnections;
